const MOBILE_VERSION_MAXWIDTH = 900;

const CURRENCY = {

  rub: 1,
  cny: 2,
  usd: 3,
  eur: 4,

  1: "rub",
  2: "cny",
  3: "usd",
  4: "eur",

}

const CURRENCY_SYMBOL = {

  [ CURRENCY.rub ]: '₽',
  [ CURRENCY.cny ]: '¥',
  [ CURRENCY.usd ]: '$',
  [ CURRENCY.eur ]: '€',

}

const DEAL_TYPES = {

  LONG: 1,
  SHORT: 2,

}

const DEAL_MOVEMENT_TYPES = {

  BUY: 1,
  SELL: 2,

}

const DEAL_PRICE_WATCH_MODE = {

  PRICE_OF_DEAL: 1,
  PRICE_OF_ONE_PAPER: 2

}

const CoT_MODE = {

  COMISSION: 1,
  TIME: 2

}

const TARIFF_COMISSION = {

  INVESTOR: 0.3,
  TRADER: 0.05,
  PREMIUM: 0.04

}

const DOCUMENTS = {

  offer: `https://scalping-calculator.ru/offer/`,
  privacy: `https://scalping-calculator.ru/privacy/`

}

export {
  
  MOBILE_VERSION_MAXWIDTH,
  CURRENCY,
  CURRENCY_SYMBOL,
  DEAL_TYPES,
  DEAL_MOVEMENT_TYPES,
  DEAL_PRICE_WATCH_MODE,
  CoT_MODE,
  TARIFF_COMISSION,
  DOCUMENTS
  
}